
export enum AuthStatus {
    checking = 'checking',
    inLogin = 'inLogin',
    authenticated = 'authenticated',
    notAuthenticated = 'notAuthenticated',
}